import { supabase } from "./supabase";

// Wraps a Supabase query promise with a hard timeout so the UI never hangs
// silently. Throws a friendly Error after `ms` milliseconds.
export function withTimeout(promise, ms = 8000, label = "operation") {
  let timer;
  const timeout = new Promise((_, reject) => {
    timer = setTimeout(
      () =>
        reject(
          new Error(
            `${label} timed out after ${ms / 1000}s. Check your network or Supabase config.`
          )
        ),
      ms
    );
  });
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
}

export async function runDiagnostics() {
  const url = process.env.REACT_APP_SUPABASE_URL;
  const key = process.env.REACT_APP_SUPABASE_ANON_KEY;
  const checks = {
    env_url: { ok: !!url, value: url || "(missing)" },
    env_key: { ok: !!key, value: key ? `${key.slice(0, 12)}…${key.slice(-6)}` : "(missing)" },
  };

  // 1. Reachability — direct fetch to Supabase REST root
  try {
    const t0 = Date.now();
    const res = await withTimeout(
      fetch(`${url}/rest/v1/`, { headers: { apikey: key } }),
      6000,
      "reachability"
    );
    checks.reachability = {
      ok: !!res.status,  // Any HTTP response = network reached Supabase (incl 401/404/200)
      value: `HTTP ${res.status} in ${Date.now() - t0}ms`,
    };
  } catch (e) {
    checks.reachability = { ok: false, value: e.message };
  }

  // 2. Shops table query
  try {
    const t0 = Date.now();
    const { data, error } = await withTimeout(
      supabase.from("shops").select("slug,name").limit(5),
      6000,
      "shops query"
    );
    if (error) throw error;
    checks.shops_query = {
      ok: true,
      value: `${data?.length || 0} shop(s) found in ${Date.now() - t0}ms`,
      data,
    };
  } catch (e) {
    checks.shops_query = { ok: false, value: e.message };
  }

  // 3. RPC test
  try {
    const t0 = Date.now();
    const { data, error } = await withTimeout(
      supabase.rpc("next_token_number", {
        p_shop_id: "00000000-0000-0000-0000-000000000000",
      }),
      6000,
      "RPC test"
    );
    if (error) throw error;
    checks.rpc = { ok: true, value: `OK (returned ${data}) in ${Date.now() - t0}ms` };
  } catch (e) {
    checks.rpc = { ok: false, value: e.message };
  }

  return checks;
}
